export default {
    /**
     * The offset at which grid columns start in the day/week view
     */
    ColumnOffset: 70,

    /**
     * Height of a row (one hour) in the calendar surface day/week view
     */
    HourRowHeight: 60,

    /**
     * Scrollbar width
     */
    ScrollbarWidth: 18,

    /**
     * Height in pixels of an all day row/item
     */
    AllDayRowHeight: 30,

    /**
     * The default duration for an appointment/meeting. TODO: Should be replaced with a setting from config
     */
    DefaultDurationInMinutes: 30,

    /**
     * Height in pixels of an item in month view
     */
    MonthItemHeight: 23,

    /**
     * Row height in the month grid
     */
    MonthRowHeight: 24,

    /**
     * Height of the day header label for a given day cell in month view
     */
    DayCellHeaderHeight: 32,

    /**
     * Offset for calculating scroll position when scrolling to working hours
     */
    scrollTopAdjustment: 10,

    /**
     * Subject line height
     */
    subjectLineHeightWithButton: 20,

    /**
     * Subject line height Without Button
     */
    subjectLineHeightWithoutButton: 16,

    /**
     * Details line height
     */
    detailsLineHeight: 15,

    /**
     * The minimum month height before scaling is neccessary
     */
    minimumScalableMonthHeight: 270,

    /**
     * The default width of the timestrip
     */
    timeStripDefaultWidth: 59,

    /**
     * The minimum width of the print preview pane
     */
    printPreviewMinPaneWidth: 732,

    /**
     * Buffer at bottom of all day well after rendering all items
     */
    allDayWellHeightBuffer: 8,

    /**
     * The number of rows of items to generate when all day well is collapsed
     */
    defaultAllDayWellCollapsedMaxRows: 5,

    /**
     * The attribute name for the expandable all day well placeholder element
     */
    allDayPlaceholderAttributeName: 'data-allday-placeholder',

    /**
     * The event's box min width to show Join Button label.
     */
    minWidthToShowJoinButtonLabel: 115,

    /**
     * The event's box min width to show Join Button icon.
     */
    minWidthToShowJoinButtonIcon: 60,

    /**
     * The ratio (Join Button Width / Event Width) to show Button with Label.
     */
    ratioToShowJoinButtonLabel: 0.7,

    /**
     * The default width for the Join button displaying the Video icon.
     */
    defaultJoinButtonWidth: 20,

    /**
     * The default left margin for the Join button
     */
    defaultJoinButtonLeftMargin: 5,

    /**
     * The number of columns to enble dynamic column widths
     */
    numColumnsToShowDynamicColumns: 4,

    /**
     * The minimum width for columns on the calendar surface
     */
    columnMinWidth: 80,
};
